module.exports = __webpack_public_path__ + "1e026e1f78f2fdb272261adf10397573-Call-Ticket.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/homeHeader/assets/Call-Ticket.png
// module id = 695
// module chunks = 0